import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@material-ui/core';
import useStyle from './MediaLinksStyle';
import SettingsContext from '../../../contexts/SettingsContext';
import Utils from '../../../services/UtilsService';
import icon from '../../../assets/image/video_library.svg';

const MediaLinks = ({ className }) => {
    const classes = useStyle();
    const rootClasses = Utils.getClassName([
        classes.root,
        className,
    ]);

    const {
        systemConfiguration: {
            HeaderVideoLinkUrl = 'https://www.talenya.com/platform-training-videos/',
        },
    } = useContext(SettingsContext);
    const { t } = useTranslation();

    const links = useMemo(() => [{
        icon,
        url: HeaderVideoLinkUrl,
        label: 'HELP_VIDEO_CHANNEL',
        title: 'HELP_VIDEO_CHANNEL_TOOLTIP',
    }], []);

    return (
        <div className={rootClasses}>
            {
                (links || []).map((link, index) => {
                    const component = <div key={index} className={classes.logo}>
                        <a href={link.url} target='_blank'
                            rel='noreferrer'
                            className={classes.urlWrapper}>
                            <img className={classes.image} src={link.icon}/>
                            <span className={classes.label}>{t(
                                link.label,
                            )} </span>
                        </a>
                    </div>;

                    return link.title
                        ? (
                            <Tooltip key={index} title={t(link.title)}>
                                {component}
                            </Tooltip>
                        )
                        : component;
                })
            }
        </div>
    );
};

export default MediaLinks;
